/* eslint-disable no-useless-computed-key */
import { Box, Button, CircularProgress, IconButton, LinearProgress, Switch, TextField, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import ButtonCom from '../../../components/button/ButtonCom';
import InputControl from '../../../components/input/InputControl';
import Card from '../../../components/layout/Card';
import TransitionsModal from '../../../components/modal/Modal';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import { colors, fonts } from '../../../utils';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import EditIcon from '@mui/icons-material/Edit';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import moment from 'moment';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import Table from '../../../components/table/Table';
import { setAllEVoting } from '../../../redux/slices/eServices/eServices';
import { successNotify } from '../../../utils/helper';


const EVoting = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { eVoting } = useSelector((state) => state.eServices);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingDoc, setIsLoadingDoc] = useState(false);
	const [tabValue, setTabValue] = useState('one');
	const [formData, setFormData] = useState({
		title: '',
		link: '',
	});
	const [webinarType, setEVotingType] = useState("Upcoming");
	const [showVideo, setShowVideo] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);

	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [selectedDate, setSelectedDate] = useState(dayjs());
	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getData = async (limit, page) => {
		setIsLoading(true)
		try {

			await Api.post(
				// tabValue === "one" ? 
				endPoints?.eServices?.fetchEVoting
				// : endPoints?.shareHolderEducation?.fetchArchive
				, {
					type: "eVoting",
					status: "all",
					limit: limit || 10,
					page: page || 1,
					user_id: clientId == 0 ? null : userId
				}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllEVoting(
							response?.data?.data?.shareholderss?.data?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								creator_name: d?.creator_name,
								title: d?.title,
								description: d?.description,
								url: d?.url,
								dt: d?.dt,
								is_enabled: d?.is_enabled,
								is_deleted: d?.is_deleted,
								date: d?.date,
								image: d?.image,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.shareholderss;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};


	const handleCreateModal = () => {
		setFormData({ title: '', description: '', url: '' })
		setOpenModal(true)
		setIsEditing(false);
	};
	const handleEditModal = (val) => {
		setFormData({ title: val.title, description: val.description, url: val.url, is_enabled: val.is_enabled, is_deleted: val.is_deleted, id: val.id, image: val.image })
		setOpenModal(true)
		setIsEditing(true);
		setSelectedDate(val.date)
	};



	const handleSubmit = async () => {
		setIsLoadingModal(true)

		if (!isEditing) {


			try {

				await Api.post(endPoints?.eServices?.createEVoting, {
					...formData,
					type: "eVoting",
					creator_id: userId,
					creator_name: fullName,
					date: selectedDate
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("E-Meeting Created Successfully");
						setIsLoadingModal(false);


					})
					.catch((error) => {

					});

			} catch (err) {
			}

		} else {


			try {

				await Api.post(endPoints?.eServices?.updateEVoting, {
					...formData,
					type: "eVoting",
					creator_id: userId,
					creator_name: fullName,
					date: selectedDate,
					is_show_video: showVideo
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("E-Meeting Updated Successfully");
						setIsLoadingModal(false);


					})
					.catch((error) => {

					});

			} catch (err) {
			}
		}
	};

	useEffect(() => {
		getData();
	}, [tabValue])
	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};
	const handleChangeTableSwitch = async (event, val) => {

		try {

			await Api.post(endPoints?.eServices?.deleteEVoting, {
				id: val.id,
				status: event.target.checked,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("E-Meeting Status Updated Successfully")
					getData();

				})
				.catch((error) => {

				});

		} catch (err) {
		}

	};
	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false)
					setFormData((prevState) => ({
						...prevState,
						image: response.data.data.link,
					}));
					successNotify("Image Uploaded Successfully")

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});

			// setErrMsg('Login Failed');

		}
	};
	const handleChangeTab = (event, newValue) => {
		setTabValue(newValue);
	};
	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Title',
			field: 'title',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.title?.length > 15 ?
					<ReadMoreReact
						text={rowData?.title}
						min={10}
						ideal={15}
						max={rowData?.title?.length}
						readMoreText="Read More"
					/> : rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.description?.length > 15 ?
					<ReadMoreReact
						text={rowData?.description}
						min={10}
						ideal={15}
						max={rowData?.description?.length}
						readMoreText="Read More"
					/> : rowData?.description}</h4>,
		},
		{
			title: 'Image',
			field: 'image',
			render: (rowData) => <img src={rowData?.image} height='60' width='60' />,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => { handleEditModal(rowData); setEVotingType("Upcoming"); }} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Status',
			field: 'is_enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},

	];
	// const columnArchive = [
	// 	{
	// 		title: 'Id',
	// 		field: 'id',
	// 		render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
	// 	},
	// 	{
	// 		title: 'Title',
	// 		field: 'title',
	// 		width: "10%",
	// 		render: (rowData) => <h4 className='font-face-R'>{rowData?.title}</h4>,
	// 	},
	// 	{
	// 		title: 'Description',
	// 		field: 'description',
	// 		render: (rowData) => <h4 className='font-face-R'>{
	// 			rowData?.description?.length > 15 ?
	// 				<ReadMoreReact
	// 					text={rowData?.description}
	// 					min={10}
	// 					ideal={15}
	// 					max={rowData?.description?.length}
	// 					readMoreText="Read More"
	// 				/> : rowData?.description}</h4>,
	// 	},
	// 	{
	// 		title: 'Creator',
	// 		field: 'creator_name',
	// 		render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
	// 	},
	// 	{
	// 		title: 'Date',
	// 		field: 'dt',
	// 		render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
	// 	},
	// 	{
	// 		title: 'Edit',
	// 		field: 'edit',
	// 		filtering: false,
	// 		render: (rowData) => (
	// 			<Tooltip title='Edit'>
	// 				<IconButton onClick={() => { handleEditModal(rowData); setEVotingType("Archive"); }} aria-label='Edit'>
	// 					<EditIcon />
	// 				</IconButton>
	// 			</Tooltip>
	// 		),
	// 	},

	// ];

	const handleOnChangeDate = (dt) => {
		setSelectedDate(dt);
	}

	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>


				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit E-Voting" : "Create E-Voting"}
						isLoading={isLoadingModal}
					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.title}
									onChange={handleChange}
									// inputProps={{ maxLength: 150 }}
									label='Title'
									name='title'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.description}
									onChange={handleChange}
									// inputProps={{ maxLength: 250 }}
									label='Description'
									name='description'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.url}
									onChange={handleChange}
									label='Url'
									name='url'
								/>
							</MarginHandler>

							{/* {webinarType === "Archive" &&
								<MarginHandler>
									<FormControlLabel control={<Checkbox sx={{
										'& .MuiSvgIcon-root': { fontSize: 22 }
									}} onChange={(e) => setShowVideo(e.target.checked)} checked={showVideo} />} label="Show Video" />

								</MarginHandler>
							} */}

							{isLoadingImg ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="image-upload"
										type="file"
										onChange={(event) => handleImageUpload(event)}
									/>
									<label htmlFor="image-upload">
										<Button
											variant="contained"
											component="span"
											fullWidth
											color='success'
											style={{ fontSize: '1em' }}
										>
											Upload Image
										</Button>
									</label>
									{formData?.image &&
										<img height={100} style={{ margin: "auto" }} src={formData?.image} />
									}
								</>}

							<LocalizationProvider dateAdapter={AdapterDayjs}>

								<Box sx={{ alignItems: "center", display: "flex" }}>

									<DesktopDatePicker
										sx={{ m: "10px 10px 10px 0px" }}
										label={`Select Date`}
										value={selectedDate}
										onChange={(e) => handleOnChangeDate(e)}
										// defaultValue={dayjs('2024-04-17T15:30')}
										minDate={dayjs()}
										renderInput={(params) => <TextField {...params} />}
									/>
									{/* <Button text="x" onClick={() => deleteTimePicker(index)} /> */}
								</Box>
							</LocalizationProvider>



							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										// backgroundColor: colorPrimary,
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.title}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "}
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>
				</Flex>







				{/* <TabContext value={tabValue}> */}
				{/* <Tabs
						value={tabValue}
						onChange={handleChangeTab}
						// textColor="secondary"
						// indicatorColor="secondary"
						sx={{
							".MuiButtonBase-root": {
								fontSize: "16px",
								fontFamily: primaryFont
							}
						}}
						aria-label="secondary tabs example"
					>
						<Tab value="one" label="Upcoming E-Voting" />
						<Tab value="two" label="Archive E-Voting" />
					</Tabs> */}
				{/* <TabPanel value="one"> */}
				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={eVoting?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="E-Voting / E-Meeting"
						// titleHeading="Upcoming E-Voting"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getData(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getData(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}
				{/* </TabPanel> */}
				{/* <TabPanel value="two">
						{isLoading ?
							<Box sx={{ m: '5rem' }}>
								<LinearProgress color="success" />
							</Box>
							:
							<Table
								columns={columnArchive}
								tableData={eVoting?.map((item) => ({ ...item }))}
								sorting
								columnsButton
								padding="3rem"
								showTitle
								paginationType='normal'
								titleHeading="Archive E-Voting"
								showToolbar={true}
								pageSize={currentParams.limit}
								onChangeRowsPerPage={(event) => getData(parseInt(event.target.value, 10), 1)}
								totalRecords={currentParams.totalRecords}
								handlePageChange={(event, newPage) => getData(currentParams.limit, newPage + 1)}
								curPage={currentParams.page - 1}
							/>
						}

					</TabPanel> */}
				{/* </TabContext> */}




			</Card>
		</>
	);
};

export default EVoting;
